<section class="services-block" data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000" id="servicios">
  <div class="header" data-aos="zoom-in-up" data-aos-delay="escalonado" data-aos-duration="800">
    <!-- <div class="subtitle-badge">{{ section3.badge }}</div> -->
    <app-badge [text]="section3.badge"></app-badge> 
    <h2 class="title-section">{{ section3.title }}</h2>
    <p class="header-description">{{ section3.description }}</p>
  </div>

  <div class="services-grid-container">
    <div class="service-card" 
         [class.active]="selectedServiceIndex === 0"
         (click)="selectService(0)"
         data-aos="fade-up" 
         data-aos-delay="100" 
         data-aos-duration="600">
      <div class="card-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" loading="lazy">
          <path [attr.d]="services[0].icon"/>
        </svg>
      </div>
      <h3 class="card-title">{{ services[0].title }}</h3>
      <p class="card-description">{{ services[0].description }}</p>
    </div>

    <div class="service-card" 
         [class.active]="selectedServiceIndex === 1"
         (click)="selectService(1)"
         data-aos="fade-up" 
         data-aos-delay="200" 
         data-aos-duration="600">
      <div class="card-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" loading="lazy">
          <path [attr.d]="services[1].icon"/>
        </svg>
      </div>
      <h3 class="card-title">{{ services[1].title }}</h3>
      <p class="card-description">{{ services[1].description }}</p>
    </div>

    <div class="central-image" data-aos="zoom-in" data-aos-delay="300" data-aos-duration="800">
      <img [src]="centralImage" alt="Paredes y Asociados" width="640" height="420" loading="lazy" decoding="async" />
    </div>

    <div class="service-card" 
         [class.active]="selectedServiceIndex === 2"
         (click)="selectService(2)"
         data-aos="fade-up" 
         data-aos-delay="400" 
         data-aos-duration="600">
      <div class="card-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" loading="lazy"> 
          <path [attr.d]="services[2].icon"/>
        </svg>
      </div>
      <h3 class="card-title">{{ services[2].title }}</h3>
      <p class="card-description">{{ services[2].description }}</p>
    </div>

    <div class="service-card" 
         [class.active]="selectedServiceIndex === 3"
         (click)="selectService(3)"
         data-aos="fade-up" 
         data-aos-delay="500" 
         data-aos-duration="600">
      <div class="card-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" loading="lazy"> 
          <path [attr.d]="services[3].icon"/>
        </svg>
      </div>
      <h3 class="card-title">{{ services[3].title }}</h3>
      <p class="card-description">{{ services[3].description }}</p>
    </div>
  </div>
</section>
